import { useCallback } from 'react';
import { usePortalsAuth } from 'portals-platform-lib';
import { trackPortalInteraction } from '../utils/usageTracker';
export function usePortalTracking(dealId) {
  const {
    user
  } = usePortalsAuth();
  // HubSpot users have userId, while contacts have contactVid
  const userRole = user !== null && user !== void 0 && user.userId ? 'seller' : 'buyer';
  return {
    userRole,
    trackAddMilestone: () => trackPortalInteraction('add-milestone', {
      userRole,
      dealId
    }),
    trackEditMilestone: updateType => trackPortalInteraction('edit-milestone', {
      userRole,
      updateType,
      dealId
    }),
    trackDeleteMilestone: () => trackPortalInteraction('delete-milestone', {
      userRole,
      dealId
    }),
    trackShareClicked: () => trackPortalInteraction('share-clicked', {
      userRole,
      dealId
    }),
    trackDeleteClicked: () => trackPortalInteraction('delete-clicked', {
      userRole,
      dealId
    }),
    trackEditDescription: () => trackPortalInteraction('edit-description', {
      dealId
    }),
    trackCancelDescription: () => trackPortalInteraction('cancel-description', {
      dealId
    }),
    // useCallback so callers can safely put this in a useCallback dep array
    trackSaveDescription: useCallback(() => trackPortalInteraction('save-description', {
      dealId
    }), [dealId])
  };
}